import { useState } from "react";
import { Formulario, Titulo } from "../../../shared";
import { accessAPI, downloadFile } from "../../../shared";

export default function FormularioFamiliaJuguetes({ clienteId, toast }) {
  const [loader, setLoader] = useState(false);
  const [factura, setFactura] = useState();
  const [juguetesTexto, setJuguetesTexto] = useState();
  const [limpiarFormulario, setLimpiarFormulario] = useState(1);

  const familiasFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "factura",
            tipoitemformularioid: 1,
            etiqueta: "Número de factura",
            requerido: true,
            respuesta: factura
          }
        ]
      },
      {
        descripcion:
          "Pegue una línea por juguete con formato [código][TAB][descripción]. La primera línea es el padre de familia. Si completa este campo y los juguetes individuales, se agregarán todos al certificado.",
        campos: [
          {
            nombre: "juguetesTexto",
            tipoitemformularioid: 11,
            etiqueta: "Listado de juguetes",
            respuesta: juguetesTexto
          }
        ]
      },
      {
        descripcion: "Este primer juguete debe ser el padre",
        campos: [
          {
            nombre: "codigo1",
            tipoitemformularioid: 1,
            etiqueta: "Código del padre de familia"
          },
          {
            nombre: "descripcion1",
            tipoitemformularioid: 1,
            etiqueta: "Descripción"
          }
        ]
      },
      {
        descripcion: "Juguete 2",
        campos: [
          {
            nombre: "codigo2",
            tipoitemformularioid: 1,
            etiqueta: "Código"
          },
          {
            nombre: "descripcion2",
            tipoitemformularioid: 1,
            etiqueta: "Descripción"
          }
        ]
      },
      {
        descripcion: "Juguete 3",
        campos: [
          {
            nombre: "codigo3",
            tipoitemformularioid: 1,
            etiqueta: "Código"
          },
          {
            nombre: "descripcion3",
            tipoitemformularioid: 1,
            etiqueta: "Descripción"
          }
        ]
      },
      {
        descripcion: "Juguete 4",
        campos: [
          {
            nombre: "codigo4",
            tipoitemformularioid: 1,
            etiqueta: "Código"
          },
          {
            nombre: "descripcion4",
            tipoitemformularioid: 1,
            etiqueta: "Descripción"
          }
        ]
      },
      {
        descripcion: "Juguete 5",
        campos: [
          {
            nombre: "codigo5",
            tipoitemformularioid: 1,
            etiqueta: "Código"
          },
          {
            nombre: "descripcion5",
            tipoitemformularioid: 1,
            etiqueta: "Descripción"
          }
        ]
      },
      {
        descripcion: "Juguete 6",
        campos: [
          {
            nombre: "codigo6",
            tipoitemformularioid: 1,
            etiqueta: "Código"
          },
          {
            nombre: "descripcion6",
            tipoitemformularioid: 1,
            etiqueta: "Descripción"
          }
        ]
      },
      {
        descripcion: "Juguete 7",
        campos: [
          {
            nombre: "codigo7",
            tipoitemformularioid: 1,
            etiqueta: "Código"
          },
          {
            nombre: "descripcion7",
            tipoitemformularioid: 1,
            etiqueta: "Descripción"
          }
        ]
      },
      {
        descripcion: "Juguete 8",
        campos: [
          {
            nombre: "codigo8",
            tipoitemformularioid: 1,
            etiqueta: "Código"
          },
          {
            nombre: "descripcion8",
            tipoitemformularioid: 1,
            etiqueta: "Descripción"
          }
        ]
      },
      {
        descripcion: "Juguete 9",
        campos: [
          {
            nombre: "codigo9",
            tipoitemformularioid: 1,
            etiqueta: "Código"
          },
          {
            nombre: "descripcion9",
            tipoitemformularioid: 1,
            etiqueta: "Descripción"
          }
        ]
      },
      {
        descripcion: "Juguete 10",
        campos: [
          {
            nombre: "codigo10",
            tipoitemformularioid: 1,
            etiqueta: "Código"
          },
          {
            nombre: "descripcion10",
            tipoitemformularioid: 1,
            etiqueta: "Descripción"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Descargar certificado",
        clases: "verde",
        callback: crearCertificadoFamilias,
        validar: true
      },
      {
        etiqueta: "Limpiar campos",
        clases: "rojo",
        callback: limpiarCamposJuguetes
      }
    ]
  };

  function crearCertificadoFamilias(camposFormulario) {
    setLoader(true);
    const juguetes = [];
    for (let i = 1; i <= 10; i++) {
      const codigo = camposFormulario[`codigo${i}`];
      const descripcion = camposFormulario[`descripcion${i}`];
      if (codigo?.trim() && descripcion?.trim()) {
        juguetes.push({ codigo, descripcion });
      }
    }

    const payload = {
      ...camposFormulario,
      clienteid: clienteId,
      juguetes
    };

    accessAPI(
      "POST",
      "admin/juguetes/certificadofamilia",
      payload,
      (respuesta) => {
        downloadFile(
          `admin/juguetes/certificadofamilia/${respuesta.nombreArchivo}`,
          respuesta.nombreArchivo,
          () => {
            setLoader(false);
          },
          (respuesta) => {
            setLoader(false);
            toast.current?.show({
              severity: "error",
              summary: "Error",
              detail: respuesta[0]?.msg || "Error desconocido",
              sticky: true
            });
          }
        );
      },
      (respuesta) => {
        setLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
      }
    );
  }

  function limpiarCamposJuguetes(camposFormulario) {
    setFactura(camposFormulario.factura);
    setJuguetesTexto(undefined);
    setLimpiarFormulario((current) => current + 1);
  }

  return (
    <>
      <Titulo>Certificado de familia de juguetes</Titulo>
      <Formulario
        config={familiasFormConfig}
        loader={loader}
        key={limpiarFormulario}
      />
    </>
  );
}
